module.exports = __webpack_public_path__ + "static/images/trash-can.b7312836240a154fd3cfc461dbee754f.svg";